import { render, staticRenderFns } from "./MarkPage.vue?vue&type=template&id=e8646ffc&scoped=true&"
import script from "./MarkPage.vue?vue&type=script&lang=js&"
export * from "./MarkPage.vue?vue&type=script&lang=js&"
import style0 from "./MarkPage.vue?vue&type=style&index=0&id=e8646ffc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8646ffc",
  null
  
)

export default component.exports